
import Intro from "../components/Intro";
import Events from "../components/Events";
import Speech from "../components/Speech";
import Calendar from './CalendarPage';
import "../../../styles/header.css";
import Plans from "../components/Plans";
import News from "../components/News";

const Home = () => {
  return (
    <div className="homewrapper">
      <header className="header">
        <div className="header-overlay"></div>
        <Intro></Intro>
      </header>
      <Events></Events>
      <Speech></Speech>
      <Plans></Plans>
      <Calendar></Calendar>
      <News limit={2}></News>
    </div>
  );
};

export default Home;
